/**
 * Fail-soft service worker registration.
 *
 * Registers the boot-resilience service worker (`/sw.js`) so that after the
 * first successful visit the app shell is served from Cache Storage. Repeat
 * visits then boot without touching the network — bypassing antivirus/firewall
 * HTTPS-scanners that can otherwise stall the JS bundle and leave the user on a
 * blank screen.
 *
 * Registration is best-effort: any failure (unsupported browser, blocked SW,
 * etc.) is swallowed so the app always boots normally, just without a cache.
 * The service worker container is injected so this stays trivially testable.
 */
export function registerServiceWorker(
  swContainer: ServiceWorkerContainer | undefined = typeof navigator !== 'undefined'
    ? navigator.serviceWorker
    : undefined,
): void {
  if (!swContainer) return

  swContainer.register('/sw.js').catch((error) => {
    // Precache is a resilience bonus, never a hard dependency for boot.
    console.warn('Service worker registration failed (app still works):', error)
  })
}
